'use client';

import './styles/@theme';
import { classes } from '@/utils/classes/classes';
import { ScrollingList } from '../scrolling-list/scrolling-list';
import { useWinnersFeed } from '@/app/components/site-wide-jackpot/hooks/use-winners-feed';
import { useStore } from '@/store/store';

export const ScrollingBanner = ({ jackpotId }: { jackpotId: string }) => {
    const { tierWinners } = useWinnersFeed(jackpotId);

    const { isDesktop } = useStore((s) => s.globals);
    const isMobileOrTablet = !isDesktop;

    return (
        <div className={classes(isMobileOrTablet ? 'mobile' : 'desktop', 'banner-wrapper')}>
            {tierWinners?.length > 4 && (
                <div className="scrolling-lists">
                    <ScrollingList tierWinners={tierWinners} isMobileOrTablet={isMobileOrTablet} />
                    <ScrollingList tierWinners={tierWinners} isMobileOrTablet={isMobileOrTablet} />
                    <ScrollingList tierWinners={tierWinners} isMobileOrTablet={isMobileOrTablet} />
                </div>
            )}
        </div>
    );
};
